import { useQuery } from "@tanstack/react-query";
import {
	EducationalEngagementFilters,
	EducationalEngagementResponse,
	reportsService,
} from "../../services/reports.service";

const useEducationalEngagementReport = (
	filters: EducationalEngagementFilters,
) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<EducationalEngagementResponse>({
		queryKey: [
			"reports-educational-engagement",
			filters.accountId,
			filters.programId,
			filters.startDate ?? "",
			filters.endDate ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 10,
		],
		queryFn: () => reportsService.getEducationalEngagement(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useEducationalEngagementReport;
